<template>
  <div v-if="showEntities" :class="{'d-flex ga-2 justify-center': showAi, 'height-transition-container': true }">
    <div :class="{'show-on-hover-item d-flex align-center ga-1 h-100': true, 'pt-2': showAi}">
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props: props }">
          <v-btn
            v-bind="props"
            class="show-on-hover-item add-data-model-btn"
            variant="plain"
            icon="mdi-plus"
            size="small"
            @click="addDataField(event.id, card.id, card.cardType.triggerType)"
            :disabled="store.state.isWorkflowDisabled"
          />
        </template>
        <span>Add field</span>
      </v-tooltip>
      <v-tooltip v-if="showAi" location="bottom">
        <template v-slot:activator="{ props: props }">
          <v-btn
            v-bind="props"
            class="show-on-hover-item add-data-model-btn"
            variant="plain"
            icon="mdi-creation"
            size="small"
            @click="createTableWithAi()"
            :disabled="store.state.isWorkflowDisabled"
          />
        </template>
        <span>From Workflow With AI</span>
      </v-tooltip>
      <v-tooltip v-if="showFilters" location="bottom" open-delay="100">
        <template v-slot:activator="{ on, props }">
          <entity-field-selector
            :card="{ ...card, entityId }"
            :offsetWidth="offsetWidth"
            @onUpdateFields="(fields) => updateDataFields(event.id, card.id, card.cardType.triggerType, fields)"
            :disabled="!entityId"
          >
            <v-btn
              class="show-on-hover-item"
              v-bind="props"
              v-on="{ ...on }"
              size="small"
              variant="plain"
              tabindex="-1"
              icon="mdi-list-status"
              :style="{ 'cursor': entityId ? 'pointer' : 'not-allowed' }"
              :disabled="store.state.isWorkflowDisabled"
            />
          </entity-field-selector>
        </template>
        <span>{{ entityId ? 'Select fields' : 'Disabled because no entity is selected' }}</span>
      </v-tooltip>
      <v-tooltip location="bottom" open-delay="100">
        <template v-slot:activator="{ on, props }">
          <v-btn
            class="show-on-hover-item"
            v-bind="props"
            v-on="{ ...on }"
            size="small"
            variant="plain"
            @click="removeCardAndModel(event, card)"
            tabindex="-1"
            icon="mdi-trash-can-outline"
            :loading="loadingDeleteModel"
            :disabled="store.state.isWorkflowDisabled"
          />
        </template>
        <span>Delete card</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import EntityFieldSelector from '@/components/EntityFieldSelector'
import useDomainModel from '@/composables/useDomainModel'
import { cardHelpers } from '@/mixins/cardHelpers'

const { event, card, generatorEventStoryFunc, generatorReadModelFunc, showAi, showFilters, parentWidth } = defineProps({
  event: Object,
  card: Object,
  generatorEventStoryFunc: Function,
  generatorReadModelFunc: Function,
  showAi: Boolean,
  showFilters: Boolean,
  parentWidth: Number
})

const store = useStore()

const showEntities = computed(() => store.state.domainModelShowEntities)
const offsetWidth = computed(() => showAi ? parentWidth / 2 - 14 : parentWidth - 48 || 0)

const { addDataField, updateDataFields, removeCardAndModel, loadingDeleteModel } = useDomainModel()

const createTableWithAi = () => {
  if (card.cardType.queryType) {
    generatorReadModelFunc?.(event.id, card.id)
  }

  if (card.cardType.triggerType) {
    generatorEventStoryFunc?.(event.id, card.id)
  }
}

const entityId = computed(() =>
  card.cardType.triggerType ? cardHelpers.methods.getEntityCard(event)?.entityId : card.entityId
)
</script>
